/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".error-message[_ngcontent-%COMP%]{font-size:80%;display:block;margin:.25rem 0;width:100%;color:#b31b29;color:var(--customTertiary)}"];
export { styles as styles };
